/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supov_OpenInputs */



/**
* | output |
* | --- |
* | "Support and notes" |
*
* @param {Supov_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const supov_open = /** @type {((inputs?: Supov_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supov_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Support and notes")
});